<template>
    <div :class="['month-label y-bar-item', Classes().alignment]" :style="`height: ${ASSETS.Timeline.MonthHeight(CONFIG)}`">{{ month }}</div>
</template>

<script>
import { CONFIG } from "@/assets/JS/Config.js";
import { ASSETS } from "@/assets/JS/Assets.js";

export default {
    name: "TimelineYBarMonthLabel",
    props: {
        month: String,
        yBarExpanded: Boolean
    },
    data: () => ({
        CONFIG,
        ASSETS
    }),
    methods: {
        Classes: function() {
            return {
                alignment: this.yBarExpanded ? "flex-x-right" : "flex-center"
            };
        }
    }
};
</script>